export const RACE_WEIGHEDIN = 'WEIGHEDIN';
export const RACE_RESULT = 'RESULT';
export const RACE_FINISHED = 'FINISHED';

export const HORSE_RACE_COMPLETE_STATUSES = [RACE_WEIGHEDIN, RACE_RESULT, RACE_FINISHED];
export const GREYHOUND_RACE_COMPLETE_STATUSES = ['Result', 'Final Result'];

export const HORSE_RACE_CASUALTIES = {
  BroughtDown: 'BD',
  CarriedOut: 'CO',
  DidNotFinish: 'DNF',
  Fell: 'F',
  HitRails: 'HR',
  PulledUp: 'PU',
  RanOut: 'RO',
  Refused: 'R',
  RefusedToRace: 'RTR',
  SlippedUp: 'SU',
  UnseatedRider: 'UR'
}

export const TZ = "Europe/London";

export const SUBSCRIPTIONS_FOOTBALL_MATCH = "FOOTBALL_MATCH";
export const SUBSCRIPTIONS_HORSE_RACE = "RACE";
export const NOT_LOGGED_IN_ERROR = "NO_LOGIN";
export const INSIDERS_LINK_CLICK_TRACKING_EVENT = "insidersLinkClick";

export const FACEBOOK_BASE_URL = "https://www.facebook.com/sharer/sharer.php";
export const TWITTER_BASE_URL = "https://twitter.com/intent/tweet";



// WEBPACK FOOTER //
// ./modules/Common/consts.js